export default "__VITE_ASSET__vtItqyqd__"